<template>
  <div class="about page">
    <div class="article">
      <div class="intro">
        <h2>DukGO는...</h2>
        <p>2020년 민족사관고등학교 융합프로젝트에서 출발했습니다.</p>
        <p>DukGO는 민족사관고등학교 학생 및 교직원의 편의를 위해</p>
        <p>휴대폰 하나로 학교의 모든 정보를 확인할 수 있는</p>
        <p>민사 통합 관리 플랫폼이 되기를 목표합니다.</p>
      </div>

      <div class="member-info">
        <h2>Members</h2>
        <p>24기 김서진</p>
        <p>24기 김정웅</p>
        <p>24기 이태훈</p>
        <p>24기 유세진</p>
        <p>24기 최준호</p>
        <p>24기 한승민A</p>
        <p>25기 강한별</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
span.bold {
  font-size: 133%;
  font-weight: 600;
}
</style>